import React from "react";

const GAMES = [
  {
    name: "Foldaway",
    key: "foldaway",
    emoji: "\uD83D\uDCD0",
    color: "#A78BFA",
    bg: "rgba(167,139,250,0.18)",
    desc: "Fold the grid until all targets align. Spatial reasoning in its purest form.",
    port: 3737,
  },
  {
    name: "Spillover",
    key: "spillover",
    emoji: "\uD83D\uDCA7",
    color: "#4ECAFF",
    bg: "rgba(78,202,255,0.18)",
    desc: "Place drops and watch them cascade. Predict the chain reaction before it happens.",
    port: 3838,
  },
  {
    name: "Lockstep",
    key: "lockstep",
    emoji: "\u2699\uFE0F",
    color: "#FFD166",
    bg: "rgba(255,209,102,0.18)",
    desc: "Move all pieces in sync to reach their goals. Every move affects everything.",
    port: 3939,
  },
  {
    name: "Burnout",
    key: "burnout",
    emoji: "\uD83D\uDD25",
    color: "#FF6B6B",
    bg: "rgba(255,107,107,0.18)",
    desc: "Light every cell exactly once. Plan your path before the fuse runs out.",
    port: 4040,
  },
  {
    name: "Echo",
    key: "echo",
    emoji: "\uD83D\uDCE1",
    color: "#00F0A0",
    bg: "rgba(0,240,160,0.18)",
    desc: "Place signal emitters so every clue is satisfied. Directional logic at its best.",
    port: 4141,
  },
] as const;

export function GameCards({ onPlay }: { onPlay?: (gameKey: string) => void } = {}) {
  return (
    <section className="w-full">
      <div className="font-mono text-[10px] tracking-[5px] uppercase text-electric-mint-dim mb-2">
        The Daily Five
      </div>
      <h2 className="font-display font-extrabold text-4xl tracking-[-1px] mb-3">
        Five Games, Five Minutes
      </h2>
      <p className="text-[15px] text-warm-gray leading-relaxed mb-10 max-w-[640px]">
        Each day brings a fresh puzzle in every game. Complete all five for the Daily Five challenge.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {GAMES.map((game, i) => (
          <button
            key={game.key}
            onClick={() => onPlay?.(game.key)}
            className="group block rounded-[16px] p-5 border border-[rgba(255,255,255,0.06)] transition-all duration-250 hover:-translate-y-[2px] text-left cursor-pointer"
            style={{
              background: `linear-gradient(145deg, #141729, ${game.bg})`,
              animationDelay: `${i * 80}ms`,
            }}
          >
            <div className="text-2xl mb-3">{game.emoji}</div>
            <div className="font-display font-bold text-sm mb-1.5" style={{ color: game.color }}>
              {game.name}
            </div>
            <p className="text-xs text-warm-gray leading-relaxed mb-4">
              {game.desc}
            </p>
            <span
              className="font-display font-semibold text-xs transition-colors duration-150"
              style={{ color: game.color }}
            >
              Play Today <span className="group-hover:translate-x-0.5 inline-block transition-transform">&rarr;</span>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
